import React, { useEffect } from "react";
import { Switch, Route, useHistory } from "react-router-dom";
import Dashboard from "./pages/Dashboard/index";
import AnalysisPage from "./pages/Analysis";
import Login from "./pages/Login";
import SignUp from "./pages/SignUp";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Welcome from "./pages/Welcome";
// import HowToUse from "./pages/HowToUse";
import NotFound from "./pages/NotFound";
import UserProfile from "./pages/UserProfile";
import UserAccountSettings from "./pages/UserAccountSettings";
import FollowingList from "./pages/FollowingList";
import RankingPage from "./pages/Ranking";
import { Billing } from "./pages/Billing";
import useAuth from "./hooks/useAuth";
import UsageLimit from "./pages/UsageLimit";
import AuthCallback from "./pages/AuthCallback";
import BugReport from "./pages/BugReport";
import UpdatePlan from "./pages/UpdatePlan";
import UnavailableResource from "./pages/UnavailableResource";
import StartTutorialDialog from "./components/StartTutorialDialog/StartTutorialDialog";
import UnsupportedAsset from "./pages/UnsupportedAsset";
import Wallet from "./pages/Wallet";
import SetupWallet from "./pages/SetupWallet";
import WalletB3 from "./pages/WalletB3";
import SetupWalletB3 from "./pages/SetupWalletB3";

const nonPremiumRoutes = [
  "/login",
  "/signup",
  "/password-recovery",
  "/reset-password",
  "/billing",
  "/welcome",
  "/auth-callback",
  "/.well-known/apple-developer-merchantid-domain-association",
];

function Routers() {
  const history = useHistory();
  const { isAuthenticated } = useAuth();

  /**
   * Determines if a user can go to given route
   */
  useEffect(() => {
    async function determineCanContinue() {
      const isAuth = isAuthenticated();
      const pathName = history.location.pathname;
      const isFreeRoute = nonPremiumRoutes.includes(pathName);

      if (!isAuth && !isFreeRoute) {
        history.push("/login");
      }
    }

    determineCanContinue();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Switch>
      <Route exact path="/Dashboard">
        <Dashboard />
      </Route>

      <Route exact path="/">
        <Dashboard />
      </Route>

      <Route path="/analysis/:key/:nav?" component={AnalysisPage} />

      <Route path="/login" component={Login} />

      <Route path="/signup" component={SignUp} />

      <Route path={"/password-recovery"} component={ForgotPassword} />

      <Route path={"/reset-password"} component={ResetPassword} />

      <Route path={"/welcome"} component={Welcome} />

      <Route path={"/user-profile"} component={UserProfile} />

      <Route path={"/how-to-use"} component={StartTutorialDialog} />

      <Route path={"/account-settings"} component={UserAccountSettings} />

      <Route path={"/following-list"} component={FollowingList} />

      <Route path={"/ranking/:assetType"} component={RankingPage} />

      <Route path={"/billing"} component={Billing} />

      <Route path={"/usage-limit/:resource"} component={UsageLimit} />

      <Route
        path={"/unavailable-resource/:resource"}
        component={UnavailableResource}
      />

      <Route path={"/plan-update"} component={UpdatePlan} />

      <Route path={"/auth-callback"} component={AuthCallback} />

      <Route path={"/bug-report"} component={BugReport} />

      <Route path={"/unsupported-fiis"} component={UnsupportedAsset} />

      <Route path={"/wallet"} component={Wallet} />

      <Route path={"/wallet-b3"} component={WalletB3} />

      <Route path={"/setup-wallet"} component={SetupWallet} />
      <Route path={"/setup-wallet-b3"} component={SetupWalletB3} />

      <Route component={NotFound} />
    </Switch>
  );
}

export default Routers;
